(function ($, Global) {
    var FormContactModalComponent = function (model) {
        this.model = model;
	}

    FormContactModalComponent.prototype.initEvents = function () {
		this.publishers();
	}

    FormContactModalComponent.prototype.publishers = function () {
        var inputsChanged = false;
        var self = this;
        $(document).on('show.bs.modal', '#modalContact', function (e) {
            var $modal = $(this)
            var $cta = $(e.relatedTarget);
            var offre = $cta.data('type-offre');
            $modal.find('[name=TypeOffre]').val(offre);
            Global.dataLayer.push({
                event: 'formModalContactOpened',
                typeOffre: offre
            })
        });
        $(document).on('hidden.bs.modal', '#modalContact', function (e) {
            if ($('.form-message.message-success.show').exists()) {
                self.restoreFormByDefault($(this));
            }
            if (!inputsChanged) return;
            Global.dataLayer.push({
                event: 'formModalContactClosed',
                typeOffre: $('#modalContact [name=TypeOffre]').val()
            })
        });
        $(document).on('submit', '.form-contact-modal', function (e) {
			e.preventDefault();

			var $this = $(this);
            var $form = $this.closest('form');
            var $loader = $this.find('.loader');
            var $inputs = $this.find('input, textarea');
            var $formMessageDefault = $('.form-message.message-default');
            var data = $this.serializeJson();

            $this.find('.form-control.is-invalid').removeClass('is-invalid');
            $this.find('.form-group .form-text').remove();
            $loader.addClass('show');
            $inputs.attr('disabled', 'disabled').css('opacity', '0.4');
            $formMessageDefault.css('opacity', '0.4');
            
            data['Indicatif'] = data['Indicatif'].trim();

            $.ajaxPost('/ajax/form/contact', data)
                .done(function (result) {
                    result.feedback = null;
                    if (!result.isSuccess) {
                        if (Object.keys(result.errors).length == 0) {
                            $formMessageDefault.removeClass('show');
                            $('.form-message.message-error').addClass('show');
                            $('.block-failed').addClass('show');
                            $('.btn-action').addClass('hide');
                        } else {
                            $formMessageDefault.css('opacity', '1');
                            $loader.removeClass('show');
                            $inputs.removeAttr('disabled').css('opacity', '1');
                        }
                    }
                    Global.ajaxCallback({
                        results: result,
                        form: $form,
                        success: function (res) {
                            $formMessageDefault.css('opacity', '1').removeClass('show');
                            $('.form-message.message-success').addClass('show');
                            $('.block-success').addClass('show');
                            $('.btn-action').addClass('hide');
                            Global.dataLayer.push({
                                event: 'formModalContactSubmitted',
                                typeOffre: $('#modalContact [name=TypeOffre]').val()
                            })
                        }
                    });
                })
                .fail(function () {
                    $formMessageDefault.removeClass('show');
                    $('.form-message.message-error').addClass('show');
                    $('.block-failed').addClass('show');
                    $('.btn-action').addClass('hide');
                });
        });

        $(document).on('click', '.modal-contact .form-message.message-error', function () {
            var $this = $(this);
            var $modal = $this.closest('.modal');

            self.restoreFormByDefault($modal);
        });

        $(document).on('change', '.form-contact-modal input, .form-contact-modal textarea', function () {
            inputsChanged = true;
        });
    }

    FormContactModalComponent.prototype.restoreFormByDefault = function ($modal) {
        var $formMessageDefault = $modal.find('.form-message.message-default');
        $modal.find('.form-message.show').removeClass('show');
        $formMessageDefault.addClass('show').css('opacity', '1');
        $modal.find('input, textarea').removeAttr('disabled').css('opacity', '1');
        $modal.find('.block-failed').removeClass('show');
        $modal.find('.block-success').removeClass('show');
        $modal.find('.btn-action').removeClass('hide');
        $modal.find('.loader').removeClass('show');
    }

    Global.FormContactModalComponent = FormContactModalComponent;
}(jQuery, window));